import React from 'react';
import ReactDOM from 'react-dom';
import BuilderContainer from './BuilderContainer';

[...document.getElementsByClassName('builder')].forEach((el) => {
  const props = {
    name: el.dataset.name,
    value: JSON.parse(el.dataset.value),
    allowed: JSON.parse(el.dataset.allowed)
  };
  ReactDOM.render(<BuilderContainer {...props} />, el);
});
